import clsx, { ClassValue } from "clsx";
import styles from "../styles.module.css";

type Props = Readonly<{
  onClick: () => void;
  className?: ClassValue;
  children: React.ReactNode;
  title: string;
  disabled?: boolean;
  isActive?: boolean;
}>;

export const PaginationButton = ({ onClick, disabled, isActive, title, className, children }: Props) => {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      title={title}
      className={clsx(className, styles["navigation-item"], {
        [styles.disabled]: disabled,
        [styles.active]: isActive,
      })}
    >
      {children}
    </button>
  );
};
